import Vue from 'vue'
import Vuex, {mapState, mapActions} from 'vuex'
import store from './store'

// Components
import ComparePanel from './components/ComparePanel'
import CompareControl from './components/CompareControl'
import PlanSelector from './components/PlanSelector'
import Notice from './components/Notice'

Vue.config.devtools = process.env.NODE_ENV === 'development'
Vue.config.sproductionTip = false
Vue.use(Vuex)

document.querySelectorAll('[data-plan-selector]').forEach(el => {
    let fragment = new DocumentFragment()
    let planId = el.getAttribute('data-plan-selector')
    
    if (!planId) {
        return
    }

    let planSelector = document.createElement('plan-selector')
    
    planSelector.setAttribute(':id', planId)
    planSelector.setAttribute('v-if', 'compareMode')
    
    fragment.appendChild(planSelector)
    el.appendChild(fragment)
})


let fragment = new DocumentFragment()
let appContainer = document.querySelector('#app')

// Instantiating the elements
let notice = document.createElement('transition')
let compareCtaMobile = document.createElement('transition')
let comparePanel = document.createElement('transition')
let compareControl = document.createElement('transition')


// Assigning the HTML content
notice.innerHTML = '<notice v-if="noticeText" key="notice-container"></notice>'
compareCtaMobile.innerHTML = ' <div v-if="!compareMode" key="comparison-cta" class="comparison-cta comparison-cta--mobile"><a href="#plans" @click.prevent="activateCompareMode">' + window.app.labels.COMPARE_PLANS + '</a></div>'
compareControl.innerHTML = '<compare-control v-if="compareMode" key="compare-control"></compare-control>'
comparePanel.innerHTML = '<compare-panel v-if="comparing" key="comparison-panel"></compare-panel>'

// Setting the attributes
notice.setAttribute('name', 'fade')
compareCtaMobile.setAttribute('name', 'cta-fade')
compareControl.setAttribute('name', 'control-fade')
comparePanel.setAttribute('name', 'compare-fade')

fragment.appendChild(notice)
fragment.appendChild(compareCtaMobile)
fragment.appendChild(compareControl)
fragment.appendChild(comparePanel)

appContainer.appendChild(fragment)

new Vue({
    el: '#app',
    store,
    components: {
        'compare-panel': ComparePanel,
        'compare-control': CompareControl,
        'plan-selector': PlanSelector,
        'notice': Notice
    },
    data() {
        return {
            app: window.app,
            activePlans: window.activePlans
        }
    },
    computed: {
        ...mapState([
            'plans',
            'compareMode',
            'comparing',
            'noticeText'
        ]),
    },
    methods: { 
        ...mapActions([
            'updateCompareMode',
            'updateComparing',
        ]),

        getPlan(id) {
            return this.activePlans.find(o => o.id === id)
        },

        activateCompareMode() {
            this.updateCompareMode(true)
        }
    },
    watch: {
        compareMode (value) {
            if (value === true) {
                let el = document.querySelector('.plans-container')
                let rect = el.getBoundingClientRect()
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                
                window.scrollTo(0, rect.top + scrollTop - 50)
            }
        }
    }
})